import React, { useEffect, useRef } from 'react';
import H2 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H2';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import { colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import { ContinueButton, Wrapper } from './styled';

const Warning = () => {
  const modalRef = useRef();
  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.open();
    }
  }, []);
  return (
    <Wrapper>
      <Modal ref={modalRef}>
        <div style={{ padding: 32 }}>
          <H2>Security Warning</H2>
          <Paragraph>
            Due to the nature of handling your private keys, please ensure that
            you are at the correct web address and did not navigate from an
            untrusted source.
          </Paragraph>
          <div
            style={{
              padding: 16,
              background: '#fbecd8',
              fontWeight: 'bold',
              marginBottom: 32,
              display: 'inline-block',
              borderRadius: 8,
            }}
          >
            https://wallet.bitcoin.com/decrypt/
          </div>
          <Paragraph
            style={{ color: colors.solid.cinnabar, fontWeight: 'bold' }}
          >
            Never share your recovery phrase or wallet.data file with anyone you
            do not trust.
          </Paragraph>
          <Paragraph
            style={{ color: colors.solid.cinnabar, fontWeight: 'bold' }}
          >
            Bitcoin.com will never ask you for your recovery phrase or password.
          </Paragraph>
          <ContinueButton
            type="button"
            onClick={() => {
              if (modalRef.current) modalRef.current.close();
            }}
          >
            <span>Continue</span>
          </ContinueButton>
        </div>
      </Modal>
    </Wrapper>
  );
};

export default Warning;
